import { getWordpressPostBySlug } from '@src/functions/wordpress'
import { useEffect, useRef, useState } from 'react'
import QuoteRequestForm from '@src/components/QuoteRequestForm'
import WordpressPost from '../common/components/WordpressPost'

export async function getServerSideProps() {
  const postJson = await getWordpressPostBySlug('ppequote')

  return {
    props: { data: Array.isArray(postJson) ? postJson[0] : postJson },
  }
}

function Post({ data }: any) {
  const [open, setOpen] = useState<boolean>(false)
  const pageRef = useRef(null)

  useEffect(() => {
    if (pageRef.current) {
      const links: NodeListOf<Element> = (pageRef.current as HTMLElement).querySelectorAll(
        '.wp-block-button__link',
      )
      if (links.length > 0) {
        links.forEach((link) => {
          if (link.textContent?.includes('quote')) {
            link.removeAttribute('href')
            link.addEventListener('click', () => {
              setOpen(true)
            })
          }
        })
      }
    }
  }, [pageRef])

  const setRef = (node: any) => {
    pageRef.current = node
  }

  return (
    <>
      <QuoteRequestForm open={open} onClose={() => setOpen(false)} />
      <WordpressPost data={data} setRef={setRef} />
    </>
  )
}

export default Post
